export default Backbone.Model.extend({
  defaults: {
    num_units: 1,
  },
});



// WEBPACK FOOTER //
// ./js/backbone/models/num_units_model.js